var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "#222222",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.922 5.27731L10.2741 9.55475C10.1895 9.69186 10.0747 9.80421 9.93987 9.88191C9.80506 9.95961 9.6545 10.0002 9.50161 10H0.928572C0.682384 9.9997 0.446359 9.89425 0.272278 9.70678C0.0981966 9.51931 0.000276495 9.26512 0 9V1C0.000276495 0.734875 0.0981966 0.480694 0.272278 0.293223C0.446359 0.105751 0.682384 0.000298264 0.928572 5.00507e-07H9.50155C9.65446 -0.000164393 9.80503 0.0404168 9.93984 0.118126C10.0746 0.195836 10.1895 0.30826 10.2742 0.445375L12.922 4.72262C12.9729 4.80475 13 4.90125 13 4.99997C13 5.09868 12.9729 5.19519 12.922 5.27731Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvLabel);
export default __webpack_public_path__ + "static/media/conv-label.8ca2a21d.svg";
export { ForwardRef as ReactComponent };